import { render } from "./admin-base-station-files.vue?vue&type=template&id=0656b8c9&ts=true&lang=pug"
import script from "./admin-base-station-files.vue?vue&type=script&lang=ts"
export * from "./admin-base-station-files.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__